import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TfButtonComponent } from "./tf-buttons/tf-buttons.component";
import { TfAnchorComponent } from "./tf-anchor-buttons/tf-anchor-buttons.component";

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [TfButtonComponent, TfAnchorComponent],
    exports: [TfButtonComponent, TfAnchorComponent]
})
export class TfButtonModule {
}
